import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-adduser-cost',
  templateUrl: './adduser-cost.component.html',
  styleUrls: ['./adduser-cost.component.scss'],
})
export class AdduserCostComponent implements OnInit {

  selectedPlan: string = 'perUser';
  userCount: number = 1;
  costPerMonth: number = 0;
  selectGstType: string = 'cgstAndSgst';

  @Input() selectedPackage: any;
  @Input() saveUsersAndCostData: any;
  @Output() proceed = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();
  @Output() saveAmountData = new EventEmitter<any>();
  @Output() storePayment: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
    if(this.saveUsersAndCostData){
      this.selectedPlan = this.saveUsersAndCostData.selectedPlan;
      this.userCount = this.saveUsersAndCostData.noOfUsers !== -1 ? this.saveUsersAndCostData.noOfUsers : 1;
      if(this.saveUsersAndCostData.taxes && this.saveUsersAndCostData.taxes.length > 0){
        this.selectGstType = this.saveUsersAndCostData?.taxes[0]?.type === 'IGST' ? 'igst' : 'cgstAndSgst';
      }
      
    }
    this.updateCostPerMonth();
  }

  updateCostPerMonth() {
    const pricing = this.selectedPackage?.pricing;
    if (!pricing) {
      return;
    }

    // Find the pricing object where userCount <= maxUsers, ignoring maxUsers === 0
    let matched = pricing.find((p: any) => p.maxUsers !== 0 && this.userCount <= p.maxUsers);

    // If not found, use the object where maxUsers === 0
    if (!matched) {
      matched = pricing.find((p: any) => p.maxUsers === 0);
    }

    this.costPerMonth = matched ? matched.pricePerUserPerMonth  : 0;
  }

  getUnlimitedUsersPrice() {
    return this.selectedPackage?.pricing.find((price: any) => price.maxUsers === -1);
  }

  get currency():any{
    return this.selectedPackage?.pricing[0].currency;
  }

  get annualCost(): any {
    if(this.selectedPlan == 'perUser'){
      return this.costPerMonth * 12 * this.userCount;
    }else if ( this.selectedPlan === 'unlimited'){
      return this.getUnlimitedUsersPrice().pricePerUserPerMonth;
    }
  }

  get cgst(): number {
    return this.calculateTax(this.annualCost, 9);
  }

  get sgst(): number {
    return this.calculateTax(this.annualCost, 9);
  }

  get igst(): number {
    return this.calculateTax(this.annualCost, 18);
  }

  get totalAmount(): number {
    return this.annualCost + this.cgst + this.sgst;
  }

  calculateTax(amount: number, rate: number): number {
    return (amount * rate) / 100;
  }


  incrementUser(): void {
    if (this.userCount < 100) {
      this.userCount++;
      this.updateCostPerMonth();
    }
  }

  decrementUser(): void {
    if (this.userCount > 1) {
      this.userCount--;
      this.updateCostPerMonth();
    }
  }

  userTypeChanged(){
    if(this.selectedPlan == 'perUser'){
      this.updateCostPerMonth();
    }else if ( this.selectedPlan === 'unlimited'){
      this.costPerMonth = -1;
    }
  }

  getTaxes(): any {
    const taxes = [];
    if (this.selectGstType === 'igst') {
      taxes.push({
        type: 'IGST',
        percentage: 18,
        amount: this.igst
      });
    } else if (this.selectGstType === 'cgstAndSgst') {
      taxes.push(
        {
          type: 'CGST',
          percentage: 9,
          amount: this.cgst
        },
        {
          type: 'SGST',
          percentage: 9,
          amount: this.sgst
        }
      );
    }
    return taxes;
  }

  serializeData(): any{
    const serializedData = {
      baseAmount: this.annualCost,
      totalAmount: this.totalAmount,
      noOfUsers: this.selectedPlan == 'perUser' ? this.userCount : -1,
      selectedPlan: this.selectedPlan,
      taxes: this.getTaxes()
    }
    return serializedData
  }

  goToNextStep() {
    this.saveAmountData.emit(this.serializeData());
    this.storePayment.emit(false);
    this.proceed.emit();
  }
}
